import React from 'react';
import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	length: '~3 years',
	timespan: '2008 - 2011',
	title: 'Articling Student / Supervisor',
	company: 'Community Legal Services',
	description: 'A legal clinic overseen by lawyers, but staffed by Law Students',
	location: 'London, Ontario',
	technologies: [],
	tools: [],
	languages: [],
	details: [
		{
			showMeOn: ['all'],
			autonomous: true,
			entry: 'Saved 80+ weekly hours for 11 peers by reverse-engineering undocumented software and repurposing it for internal automation',
		},
		{
			showMeOn: ['none'],
			entry: 'Scripted, directed, and produced a series of instructional videos for a litigation course',
		},
	],
};
